<div  #tooltip class="gc-tooltip" style="visibility: hidden;" >
    <ng-content></ng-content>
</div>
<pm-icon-search-plus #zoomIn IconSize="1" style="position:absolute; top:10px; left:10px; "></pm-icon-search-plus>
<pm-icon-search-minus #zoomOut IconSize="1" style="position:absolute; top:30px; left:10px"></pm-icon-search-minus>
<pm-icon-arrows IconSize="1" #reset style="position:absolute; top:52px; left:10px"></pm-icon-arrows>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/graph/graph-component.html